import React from "react";
import { motion } from "framer-motion";
import { MessageSquare, CheckCircle2, ShieldCheck, MapPin, Handshake, ArrowRight } from "lucide-react";
import { SMS_HREF, PHONE_DISPLAY, reveal, getCurrentTier } from "./constants";
import { track } from "@/lib/analytics";

export function Hero() {
  const tier = getCurrentTier();
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-[#FFFFFF]"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1585261818192-d12b279f8fea?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85"
          alt="Midwest craftsman home"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#FFFFFF] via-[#FFFFFF]/92 to-[#FFFFFF]/40 md:to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-4 pb-16 sm:pt-8 sm:pb-24">
        <motion.div {...reveal} className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#5FBE1F] mb-4">
            <span className="w-6 h-px bg-[#5FBE1F]" />
            One guy · One ladder · Done right
          </div>

          <h1 className="font-display text-[2.4rem] leading-[1.08] sm:text-6xl lg:text-7xl tracking-normal text-[#000000]">
            Clean gutters,
            <br />
            <span className="text-[#5FBE1F]">honest price,</span>
            <br />
            neighborly service.
          </h1>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href={SMS_HREF}
              onClick={() => track("text_gutters_click", { location: "hero" })}
              className="inline-flex items-center justify-center gap-2 bg-[#5FBE1F] text-white font-bold text-base sm:text-lg px-7 py-5 sm:py-5 rounded-sm shadow-sm hover:bg-[#4A9818] hover:-translate-y-0.5 transition-all duration-300"
              data-testid="hero-text-cta"
            >
              <MessageSquare className="w-5 h-5" />
              Text "Gutters" to {PHONE_DISPLAY}
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#0A0A0A] text-[#0A0A0A] font-bold px-7 py-5 rounded-sm hover:bg-[#0A0A0A] hover:text-white transition-all duration-300"
              data-testid="hero-form-cta"
            >
              Or fill the form
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2 sm:gap-3" data-testid="hero-trust-pills">
            <div className="inline-flex items-center gap-3 px-5 py-3 bg-[#0A0A0A] text-white rounded-full shadow-sm" data-testid="hero-trust-insured">
              <span className="grid place-items-center w-9 h-9 rounded-full bg-[#5FBE1F]">
                <ShieldCheck className="w-5 h-5 text-black" strokeWidth={2.4} />
              </span>
              <div className="pr-2 font-display text-lg sm:text-xl leading-none tracking-wide">
                INSURED
              </div>
            </div>
            <div className="inline-flex items-center gap-3 px-5 py-3 bg-[#0A0A0A] text-white rounded-full shadow-sm" data-testid="hero-trust-local">
              <span className="grid place-items-center w-9 h-9 rounded-full bg-[#5FBE1F]">
                <MapPin className="w-5 h-5 text-black" strokeWidth={2.4} />
              </span>
              <div className="pr-2 font-display text-lg sm:text-xl leading-none tracking-wide">
                LOCAL
              </div>
            </div>
            <div className="inline-flex items-center gap-3 px-5 py-3 bg-[#0A0A0A] text-white rounded-full shadow-sm" data-testid="hero-trust-neighborly">
              <span className="grid place-items-center w-9 h-9 rounded-full bg-[#5FBE1F]">
                <Handshake className="w-5 h-5 text-black" strokeWidth={2.4} />
              </span>
              <div className="pr-2 font-display text-lg sm:text-xl leading-none tracking-wide">
                NEIGHBORLY
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#4A4A46]">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-[#0A0A0A]" />
              <span>{tier.heroBadge}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-[#0A0A0A]" />
              <span>Window screen repair</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
